'use client';

import { Tooltip, TooltipTrigger, TooltipContent } from '../UIComponents/Tooltip';

/**
 * Beta badge component displayed next to the logo.
 * Uses neutral gray styling with a tooltip explaining beta status.
 * Tooltip appears on the right for tablets+ (≥768px), bottom for mobile.
 */
export default function BetaBadge() {
	const isTabletOrAbove = typeof window !== 'undefined' && window.innerWidth >= 768;

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<span className='bg-accent/60 text-muted-foreground hover:bg-accent/80 ml-2 inline-flex cursor-default items-center rounded-full px-2 py-0.5 text-[10px] font-medium transition-colors'>
					Beta
				</span>
			</TooltipTrigger>
			<TooltipContent
				side={isTabletOrAbove ? 'right' : 'bottom'}
				sideOffset={8}
			>
				<p className='max-w-[200px] text-center'>This is a beta release. Features may change and bugs may exist.</p>
			</TooltipContent>
		</Tooltip>
	);
}
